define('datasource-manager/lib/Datasource',['require','exports','module','../env','./extend','./resolveParams'],function(require,exports,module){
	var getEnvString = require('../env'),
		extend = require('./extend'),
		resolveParams = require( './resolveParams' );

	var ENV_PRE 		= "env_",
		EMPTY			= "";

	function DataSource(dataSourceName,dataSourceCollection){
		var env = this.getEnvString(),
			defaults = dataSourceCollection.defaults,
		 	datasource = dataSourceCollection[dataSourceName]||{};

		extend(extend(this,defaults,datasource),this[env] || this[env.toLowerCase()]);
		this.name=dataSourceName;
		this.compiledUrls={};
		this._dataSource=datasource;
	};

	DataSource.prototype = {
		getEnvString : function(){
			return ENV_PRE + getEnvString();
		},
		getUrl :  function(params){
			return resolveParams(this.getUrlTemplate(),params);
		},

		getUrlTemplate : function(){
			var env=this.getEnvString();
			return this.compiledUrls[env]=this.compiledUrls[env] || (this.urlTemplate || 
				this.domain &&
					(this.domain + this.pathTemplate + (this.fileTemplate||EMPTY)) || EMPTY);
		},

		getNamespace : function(params){
			return resolveParams(this.namespace,params);
		},

		getPostBodyTemplate : function(params){
			return resolveParams(this.postBodyTemplate,params);
		},
		transform  : function(res,req){
			return this.transformer(res, this, req.params,req.xhr);
		}
	};

	return DataSource;
});
